<template>
  <div class="table_index">
    <JmsTable
      :option="listOpt"
      :data="tableData"
      :tablePageVisible="false"
      @select-all="handleSelectAll"
      @select="handleSelectionChange"
      @row-click="rowEdit"
      :table-loading="loading"
    >
      <template #goodDetail="scope">
        <div
          @click.stop="rowView(scope.row, scope.row.$index)"
          :class="{
            errorData:
              !scope.row.interGoodsInfolDTOS[0].englishName ||
              !scope.row.interGoodsInfolDTOS[0].goodsNumber ||
              !scope.row.interGoodsInfolDTOS[0].goodsValue ||
              !scope.row.interGoodsInfolDTOS[0].pricecurrency,
          }"
          style="height: auto; color: red; cursor: pointer"
        >
          {{ $lang('查看') }}
        </div>
      </template>
    </JmsTable>
    <good-detail ref="item-detail" :itemList="itemList" sourceType="batchEntry" @goods-edit-save="goodsEditSave"></good-detail>
  </div>
</template>
<script>
import JmsTable from '@components/jms-widget/jms-table-scroll/index.vue'
import goodDetail from '../components/goodDetail.vue'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'TableIndex',
  data() {
    return {
      itemList: [],
      isShowFirst: false,
      loading: false,
      tableData: [],
    }
  },
  props: {
    tableList: {
      type: Array,
      default: () => [],
    },
    tabActive: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    tableList: {
      handler(newValue, oldValue) {
        this.tableData = cloneDeep(newValue)
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    goodDetail,
    JmsTable,
  },
  computed: {
    listOpt() {
      return {
        border: true,
        selection: true,
        menu: false,
        index: true,
        tableHeight: 490,
        currentRow: true,
        rowKey: 'id',
        column: [
          {
            label: '服务类型',
            prop: 'serviceTypeName',
          },
          {
            label: '客户订单号',
            prop: 'customerOrderId',
            minWidth: 100,
          },
          {
            label: '收件人国家',
            prop: 'receiverCountryName',
            minWidth: 100,
            render: (h, row) => {
              return <div class={!row.receiverCountryName && this.tabActive === 1 ? 'errorData' : ''}>{row.receiverCountryName || '--'}</div>
            },
          },
          {
            label: '收件人姓名',
            prop: 'receiverName',
            minWidth: 100,
            render: (h, row) => {
              return <div class={!row.receiverName && this.tabActive === 1 ? 'errorData' : ''}>{row.receiverName || '--'}</div>
            },
          },
          // {
          //   label: '收件人区号',
          //   prop: 'receiverPhoneAreacode',
          //   minWidth: 100,
          //   render: (h, row) => {
          //     return <div class={!row.receiverPhoneAreacode && this.tabActive === 1 ? 'errorData' : ''}>{ row.receiverPhoneAreacode || '--' }</div>
          //   }
          // },
          {
            label: '收件人电话',
            prop: 'receiverMobilePhone',
            minWidth: 100,
            render: (h, row) => {
              return <div class={!row.receiverMobilePhone && this.tabActive === 1 ? 'errorData' : ''}>{row.receiverMobilePhone || '--'}</div>
            },
          },
          {
            label: '收件人证件号',
            prop: 'receiverIdCard',
            minWidth: 100,
          },
          {
            label: '收件省份',
            prop: 'receiverProvinceName',
            render: (h, row) => {
              return <div class={!row.receiverProvinceName && this.tabActive === 1 ? 'errorData' : ''}>{row.receiverProvinceName || '--'}</div>
            },
          },
          {
            label: '收件城市',
            prop: 'receiverCityName',
            render: (h, row) => {
              return <div class={!row.receiverCityName && this.tabActive === 1 ? 'errorData' : ''}>{row.receiverCityName || '--'}</div>
            },
          },
          {
            label: '收件区域',
            prop: 'receiverAreaName',
          },
          {
            label: '收件详细地址',
            prop: 'receiverDetailedAddress',
            minWidth: 100,
            render: (h, row) => {
              return <div class={!row.receiverDetailedAddress && this.tabActive === 1 ? 'errorData' : ''}>{row.receiverDetailedAddress || '--'}</div>
            },
          },
          {
            label: '寄件人国家',
            prop: 'senderCountryName',
            minWidth: 100,
            hide: !this.containSender,
            render: (h, row) => {
              return <div class={!row.senderCountryName && this.tabActive === 1 ? 'errorData' : ''}>{row.senderCountryName || '--'}</div>
            },
          },
          {
            label: '寄件人姓名',
            prop: 'senderName',
            minWidth: 100,
            hide: !this.containSender,
            render: (h, row) => {
              return <div class={!row.senderName && this.tabActive === 1 ? 'errorData' : ''}>{row.senderName || '--'}</div>
            },
          },
          {
            label: '寄件人区号',
            prop: 'senderPhoneAreacode',
            minWidth: 100,
            hide: !this.containSender,
            render: (h, row) => {
              return <div class={!row.senderPhoneAreacode && this.tabActive === 1 ? 'errorData' : ''}>{row.senderPhoneAreacode || '--'}</div>
            },
          },
          {
            label: '寄件人联系手机',
            prop: 'senderMobilePhone',
            minWidth: 120,
            hide: !this.containSender,
            render: (h, row) => {
              return <div class={!row.senderMobilePhone && this.tabActive === 1 ? 'errorData' : ''}>{row.senderMobilePhone || '--'}</div>
            },
          },
          {
            label: '省份',
            prop: 'senderProvinceName',
            hide: !this.containSender,
            render: (h, row) => {
              return <div class={!row.senderProvinceName && this.tabActive === 1 ? 'errorData' : ''}>{row.senderProvinceName || '--'}</div>
            },
          },
          {
            label: '寄件城市',
            prop: 'senderCityName',
            hide: !this.containSender,
            render: (h, row) => {
              return <div class={!row.senderCityName && this.tabActive === 1 ? 'errorData' : ''}>{row.senderCityName || '--'}</div>
            },
          },
          {
            label: '寄件区域',
            prop: 'senderAreaName',
            hide: !this.containSender,
          },
          {
            label: '寄件详细地址',
            prop: 'senderDetailedAddress',
            hide: !this.containSender,
            minWidth: 100,
            render: (h, row) => {
              return <div class={!row.senderDetailedAddress && this.tabActive === 1 ? 'errorData' : ''}>{row.senderDetailedAddress || '--'}</div>
            },
          },
          {
            label: '物品明细',
            prop: 'goodDetail',
            slot: true,
          },
          {
            label: '物品重量',
            prop: 'packageTotalWeight',
            render: (h, row) => {
              return <div class={!row.packageTotalWeight && this.tabActive === 1 ? 'errorData' : ''}>{row.packageTotalWeight || '--'}</div>
            },
          },
          {
            label: '长(cm)',
            prop: 'packageLength',
          },
          {
            label: '宽(cm)',
            prop: 'packageWide',
          },
          {
            label: '高(cm)',
            prop: 'packageHigh',
          },
          {
            label: '产品类型',
            prop: 'expressTypeName',
            render: (h, row) => {
              return (
                <div class={(!row.expressTypeName || !row.expressTypeCode) && this.tabActive === 1 ? 'errorData' : ''}>
                  {row.expressTypeName || '--'} | {row.expressTypeCode || '--'}
                </div>
              )
            },
          },
          {
            label: '物品类型',
            prop: 'goodsTypeName',
            render: (h, row) => {
              return <div class={!row.goodsTypeName && this.tabActive === 1 ? 'errorData' : ''}>{row.goodsTypeName || '--'}</div>
            },
          },
          {
            label: '代收货款金额',
            prop: 'codMoney',
            minWidth: 100,
          },
          {
            label: '代收货款币别',
            prop: 'codCurrencyTypeName',
            minWidth: 100,
          },
          {
            label: '备注',
            prop: 'remarks',
          },
        ],
      }
    },
  },
  methods: {
    rowView(row, index) {
      this.itemList = row.interGoodsInfolDTOS || []
      this.$refs['item-detail'].showDialog(index, row.interGoodsInfolDTOS)
    },
    goodsEditSave(table, index) {
      this.$nextTick(() => {
        this.$set(this.tableData[index], 'interGoodsInfolDTOS', table)
        this.$emit('handleSingle', this.tableData[index])
      })
    },
    handleSelectAll(val) {
      this.$emit('selectChange', val, {}, 1)
    },
    handleSelectionChange(val, currentRow) {
      this.$emit('selectChange', val, currentRow, 2)
    },
    rowEdit(row, column, event) {
      this.$emit('rowEditTable', cloneDeep(row))
    },
  },
}
</script>
<style scoped lang="scss">
.table_index {
  ::v-deep {
    td {
      .cell {
        .errorData {
          background: rgba(245, 34, 45, 0.5);
          height: 25px;
          cursor: pointer;
          text-align: center;
          color: #fff;
        }
      }
    }
    th {
      .cell {
        color: #999999;
      }
    }
  }
}
</style>
